import { render } from "./ImageUploader.vue?vue&type=template&id=1d7dd664&scoped=true&ts=true"
import script from "./ImageUploader.vue?vue&type=script&lang=ts"
export * from "./ImageUploader.vue?vue&type=script&lang=ts"

import "./ImageUploader.vue?vue&type=style&index=0&id=1d7dd664&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d7dd664"]])

export default __exports__